import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Details } from 'components/shopItems/ShopItemPicker/ItemPreviewDialog/Details';
import { ItemImagePreview } from 'components/shopItems/ShopItemPicker/ItemPreviewDialog/ItemImagePreview';

import type { DefaultContent_clubShopItem } from './__generated__/index.graphql';

type Props = {
  item: DefaultContent_clubShopItem;
  itemEquipped?: boolean;
};

export const DefaultContent = ({ item, itemEquipped }: Props) => {
  return (
    <>
      <ItemImagePreview
        pictureUrl={item.pictureUrl}
        name={item.name}
        type={item.position}
      />
      <Details item={item} itemEquipped={itemEquipped} />
    </>
  );
};

DefaultContent.fragments = {
  clubShopItem: gql`
    fragment DefaultContent_clubShopItem on ClubShopItem {
      ... on ShopItemInterface {
        id
        pictureUrl
        name
        position
        myPurchasesCount
        myLimitResetAt
        disabled
      }
      ...Details_shopItem
    }
    ${Details.fragments.shopItem}
  ` as TypedDocumentNode<DefaultContent_clubShopItem>,
};
